<script lang="ts" setup>

const {findAllCategories} = useCategory()

const {data: categories} = await useAsyncData<Map<string, string>>(
    `map-categories`,
    async () => {
      const allCategories = await findAllCategories();
      const categoryMap: Map<string, string> = new Map();
      for (const {slug, description} of allCategories) {
        categoryMap.set(slug, description);
      }
      return categoryMap
    },
    {default: () => new Map()}
);

const route = useRoute();
const breadcrumbData = [{
  title: 'Home',
  link: '/',
  subitems: [
    {title: 'Eventos', link: '/eventos'},
    {title: categories.value.get(route.params?.slug || '')}
  ]
}]
</script>
<template>
  <EventList :breadcrumb-data="breadcrumbData" :category-slug="route.params?.slug || ''"/>
</template>
